import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    Renderer2,
    ViewChild
} from '@angular/core';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
import { Store } from '@src/store';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

export interface IEnforcementTable {
    id: number;
    isEnabled: boolean;
    isInherited: boolean;
    isEdit: boolean;
    policyName: string;
    environmentTypes: string;
    scope: string;
    action: string;
    edit: string;
}

@Component({
    selector: 'enforcement',
    template: require('./enforcement.component.html'),
    styles: [require('./enforcement.component.scss')]
})
export class EnforcementComponent implements OnInit, AfterViewInit{

    @Input() public processData: any;
    @Input() public indexInList: any;
    @Input()
    public get enforcement() {
        return this._enforcement;
    }
    public set enforcement(value) {
        if (!value) {
            return;
        }
        this.tempEnforcement = { ...value };
        this.selectedItem = value;
        this._enforcement = value;
        this.editModeState = false;
        this.selectAllCheckBox = false;
        this.dataSource.filter = JSON.stringify(this.filterValues);
        this.tableDataProcessing();
    }
    private _enforcement: any;

    @Output() public onSave: EventEmitter<any> = new EventEmitter<any>();

    private tempEnforcement: any;
    private selectedItem: any;
    private copyEnforcement: any;
    private actionHash = {
        1: 'Warning',
        2: 'Block',
        3: 'Backup and proceed'
    };

    public editDropdownOptionsArray = [
        { key: 1, value: 'Warning' },
        { key: 2, value: 'Block' },
        { key: 3, value: 'Backup and proceed' }];

    public editModeState: boolean = false;
    public showSelectCheckBox: boolean = true;
    public selectAllCheckBox: boolean = false;
    public showInheritedCheckBox: boolean = true;

    public displayedColumns = ['isEnabled', 'policyName', 'environmentTypes', 'scope', 'action', 'isEdit'];
    private columns: any[] = [
        { field: 'isEnabled', width: 60  },
        { field: 'policyName', width: 350 },
        { field: 'environmentTypes', width: 150 },
        { field: 'scope', width: 60 },
        { field: 'action', width: 60 },
        { field: 'isEdit', width: 50 }
    ];
    public dataSource = new MatTableDataSource<IEnforcementTable>([]);
    public filterValues: any = {};

    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
    private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;

    constructor(private store: Store, private renderer: Renderer2) {
        this.selectedItem = null;

    }
    public ngOnInit(): void {
        this.setupFilter();
        setTimeout(() => {
            this.dataSource.sort = this.sort;
        });
        this.setDisplayedColumns();
    }

    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    private tableDataProcessing() {
        if (!this.enforcement.policies) {
            return;
        }
        const data = [];
        this.enforcement.policies.forEach((policy) => {
            data.push({
                id: policy.policy.Key,
                action: policy.action,
                isEnabled: policy.isEnabled,
                isInherited: policy.isInherited,
                isEdit: false,
                environmentTypes: policy.PolicyData.environmentTypes.map(item => item.Value).join(', '),
                policyName: policy.policy.Value,
                scope: (policy.scope) ? policy.scope.scopeName : ''
            });
        });
        this.dataSource.data = data;
        // this.dataSource = new MatTableDataSource<IEnforcementTable>(data);
    }

    private setupFilter(): void {
        this.dataSource.filterPredicate = ((data: IEnforcementTable, filter: string): boolean => {
            const filterValues = JSON.parse(filter);
            return (this.showSelectCheckBox ? data.isEnabled : true) &&
                ((!this.showInheritedCheckBox ? !data.isInherited : true)
                    && (this.showSelectCheckBox ? data.isEnabled : true)) &&
                (filterValues && filterValues.policyName ? data.policyName && this.strForFilter(data.policyName)
                    .indexOf(filterValues.policyName) !== -1 : true);
        });
    }

    private strForFilter(val: any): string {
        return val.toString().trim().toLowerCase();
    }

    public selectAll() {
        this.dataSource.data.map((item: IEnforcementTable) =>
            item.isEnabled = (!item.isInherited) ? this.selectAllCheckBox : item.isEnabled);
    }

    public applyFilter(column: string, filterValue: string) {
        this.filterValues[column] = filterValue.toLowerCase();
        this.dataSource.filter = JSON.stringify(this.filterValues);
    }

    public clearFilter(): void {
        this.filterValues = {};
        this.dataSource.filter = JSON.stringify(this.filterValues);
    }

    public editMode() {
        this.editModeState = !this.editModeState;
        if (!this.editModeState) {
            this.dataSource.data.map((item:any) => item.isEdit = false);
        }
    }

    public changeEditing(element: IEnforcementTable) {
        element.isEdit = !element.isEdit;
    }

    public getActions(actions) {
        let result : string = '';
        actions.forEach((action, i, arr) => {
            result += (i === arr.length - 1) ? this.actionHash[action] : `${this.actionHash[action]}, `;
        });
        return result;
    }

    public cancel() {
        this.enforcement = this.tempEnforcement;
        this.editModeState = false;
        this.showInheritedCheckBox = true;
        this.showSelectCheckBox = true;
        this.clearFilter();
    }

    public saveEnforcement(): void {
        this.editModeState = false;
        this.copyEnforcement = Object.assign({}, this.enforcement);
        this.copyEnforcement.policies = [];

        this.dataSource.data.forEach((item) => {
            if (item.isEnabled && !item.isInherited) {
                const policy = { ... this.enforcement.policies.find(policy => policy.policy.Key === item.id) };
                policy.action = item.action;
                policy.isEnabled = item.isEnabled;
                this.copyEnforcement.policies.push(policy);
            }
        });

        this.store.dispatch({
            type: policyEngineActions.SAVE_ENFORCEMENT,
            payload: {
                scopeTypeId: this.enforcement.scopeTypeId,
                scopeId: this.enforcement.scopeId,
                enforcementData: this.copyEnforcement
            }
        }).then(() => {
            this.onSave.emit({ selectedItem: this.selectedItem, indexInList: this.indexInList });
        });
    }

    private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }

    private setDisplayedColumns() {
        this.columns.forEach((column, index) => {
            column.index = index;
            this.displayedColumns[index] = column.field;
        });
    }

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
        this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }

    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||

            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (this.currentResizeIndex === index && width > 40) {
                    this.setColumnWidthChanges(index, width);
                }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-enforcement/enforcement/enforcement.component.ts